import { Component, OnInit, Inject } from '@angular/core';

import * as CryptoJS from 'crypto-js';
import { AuthenticationService } from '../../../services/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonfilterService } from '../../../services/commonfilter.service';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-verify-modal',
    templateUrl: './verify-modal.component.html',
    styleUrls: ['./verify-modal.component.css']
})
export class VerifyModalComponent implements OnInit {
    secondpassword;
    iframeSrc: any;
    configData: any = {};
    ynwDomain: any;
    loginId;
    password: string;
    enckey: any;
    encrpytedPassword: any;
    isVerified = false;
    api_error: any;
    constructor(
        private commonFilter: CommonfilterService,
        private authService: AuthenticationService,
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: number,
        private domSanitizer: DomSanitizer)  {

            this.loginId = localStorage.getItem('supportName');
            this.password = localStorage.getItem('supportPass');
            this.enckey = CryptoJS.AES.encrypt(localStorage.getItem('supportPass'),
            localStorage.getItem('supportName')).toString();
            this.encrpytedPassword = this.enckey;
        }

    ngOnInit() {
    }
    verifySecondpassword() {
        const data = {
            secondPassword: this.secondpassword
        };
        this.commonFilter.getConfigData()
            .subscribe(config => {
                this.configData = config;
                console.log('congifData' + JSON.stringify(this.configData));
                console.log('newUI');
                 this.ynwDomain = this.configData.ynwDomain;
              // this.ynwDomain = 'https://test.jaldee.com';
                // environment.jaldeeUrl='/jaldee';
               // this.data = 22957;
                this.authService.verifySecondPassword(data)
                    .subscribe(res => {
                        // alert('succeess' + JSON.stringify(res));
                        // const enckey = CryptoJS.AES.encrypt(localStorage.getItem('supportPass'),
                        //     localStorage.getItem('supportName')).toString();
                        // const loginPswd = enckey;
                        // console.log('password' + loginPswd);
                        const userdata = {
                            loginId: this.loginId,
                            password: this.password,
                            accountId: this.data

                        };
                        const encrypted_data = {
                            loginId: this.loginId,
                            password: this.encrpytedPassword,
                            accountId: this.data

                        };
                        this.isVerified = true;
                        this.iframeSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(this.ynwDomain + environment.jaldeeUrl);
                        this.authService.clearStorage(userdata, this.ynwDomain)
                            .subscribe(response => {
                                console.log('clear storage response is .....' + response);

                                localStorage.removeItem('ynw-user');
                                localStorage.removeItem('ynw-credentials');
                                localStorage.removeItem('isBusinessOwner');
                                console.log('logout success');

                                this.authService.logintoProviderAccount(userdata, this.ynwDomain)
                                    .subscribe(dataObj => {

                                        console.log('response after  ' + JSON.stringify(dataObj));
                                        localStorage.setItem('ynw-user', JSON.stringify(dataObj));
                                        localStorage.setItem('ynw-credentials', JSON.stringify(encrypted_data));
                                        localStorage.setItem('isBusinessOwner', 'true');
                                        /* 						if($location.absUrl().indexOf('youneverwait.com') > -1){ */
                                        const obj = {
                                            'response': dataObj,
                                            'userdata': encrypted_data
                                        };

                                        console.log('calling new tab' + this.ynwDomain + environment.jaldeeUrl);
                                        console.log('encrpted' + JSON.stringify(encrypted_data));
                                        const iframe = document.getElementById('receiver');
                                        if (iframe == null) { return; }
                                        const iWindow = (<HTMLIFrameElement>iframe).contentWindow;
                                         console.log('obj...' + JSON.stringify(obj));
                                         console.log('domain...' + this.ynwDomain + environment.jaldeeUrl);
                                        iWindow.postMessage(obj, this.ynwDomain + environment.jaldeeUrl);
                                       // setTimeout(() => {
                                            window.open(this.ynwDomain + environment.jaldeeUrl);
                                           //}, 5000
                                       // );

                                    });
                            });
                    },
                    (error) => {
                        this.api_error = error.error;
                      }
                   );


            });
    }
}

